export enum ACTION_BUTTON {
  BULK_DELETE = "bulkDelete",
}

const ReportConstants = {
  REPORT_CONSTANTS: {
    TABLE_WRAPPER_DATA: {
      title: "Reports",
      HeaderData: [
        {
          field: "module",
          headerName: "Module",
          width: 100,
        },
        {
          field: "type",
          headerName: "Report Type",
          width: 100,
        },
        {
          field: "createdBy",
          headerName: "User",
          width: 120,
        },
        {
          field: "createdAt",
          headerName: "Report Generated At",
          width: 100,
        },
        {
          type: "date",
          field: "reportDateRange",
          headerName: "Report Date range",
          width: 100,
        },
        {
          field: "status",
          headerName: "Status",
          width: 100,
          // filter: true,
          // filterObj: {
          //   type: "autocomplete",
          //   fieldKey: "status",
          //   fieldName: "status",
          //   fieldFullName: "c.status",
          //   multiple: true,
          //   key: `autoComplete-status`,
          //   label: "Status",
          //   items: [],
          // },
        },
        {
          field: "progress",
          headerName: "Progress",
          width: 150,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 100,
          hide: false,
        },
      ],
      FilterFormData: [
        {
          type: "selectBox",
          fieldName: "module",
          multiple: false,
          enableOnChangeFetch: true,
          key: `selectBox-module`,
          label: "Module",
          items: [],
        },
        {
          type: "selectBox",
          fieldName: "type",
          multiple: false,
          enableOnChangeFetch: true,
          key: `selectBox-reportType`,
          label: "Report Type",
          items: [],
        },
        {
          type: "dateRange",
          fieldName: "dateRange",
          key: `dateRange-filter`,
          placeholderText: "Date",
          label: "Date",
          isTextField: true,
          autoUpdateInput: false,
          autoApply: true,
          showDropdowns: true,
          linkedCalendars: true,
          maxSpan: {
            month: "1",
          },
          locale: {},
        },
      ],
      loadMore: {
        name: "loadMore",
        disabled: false,
        pageSize: 20,
      },
      defaultFiltersObj: {
        module: {
          key: "module",
          value: "",
        },
        type: {
          key: "type",
          value: "",
        },
        dateRange: {
          key: "dateRange",
          value: {
            startDate: new Date(),
            endDate: new Date(),
          },
        },
        status: {
          key: "status",
          value: [],
        },
        pageNumber: 0,
      },
    },

    READ_ONLY_ROLE: "LAST_MILE_VIEWER",
    READ_ONLY_ROLE_STANDARD: "LAST_MILE_VIEWER_STANDARD",
    READ_ONLY_ROLE_EXPRESS: "LAST_MILE_VIEWER_EXPRESS",
    DISPATCHER_ROLE: "LAST_MILE_DISPATCHER",
    DISPATCHER_ROLE_EXP: "LAST_MILE_DISPATCHER_EXPRESS",
    DISPATCHER_ROLE_STD: "LAST_MILE_DISPATCHER_STANDARD",
    USERNAME_USERTYPE: "External",
    RELEASE_ASSIGNEE_CONTENT:
      "This will result in clearing the assigned slots to the driver / helper.Please confirm to proceed.",
    END_ACTIVE_SESSION_CONTENT:
      "Ending a session will result in losing all unsaved data from the device. Please confirm to proceed.",
    END_SESSION: "END SESSION",
    LAST_MILE_QC_EXECUTIVE_ROLE: "ROLE_LAST_MILE_QC_EXECUTIVE",
    USER_ROLE_TYPE_ERROR:
      "Only Drivers or QC Executives roles can be External User.",
    POP_UP_MESSAGE_CONSTANT: {
      DELETE_USER_RECORD: "Delete User Data",
      DOWNLOAD_USER_INFORMATION_CONFIRMATION:
        "Are you sure you want to delete the user data ? This action cannot be undone.",
    },
    ROLE_LAST_MILE_HELPER: "ROLE_LAST_MILE_HELPER",
    USER_TYPE: {
      INTERNAL: "Internal",
      PORTAL_USER: "Portal User",
      EXTERNAL: "External",
      APP_USER: "App User",
    },
    SERVICE_TYPE: {
      STANDARD: "STANDARD",
      EXPRESS: "EXPRESS",
    },
    MULTIPLE_COUNTRIES_ROLE: {
      ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
    },
  },
};

export default ReportConstants;
